import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'emotion-theming';
import styled from '@emotion/styled';
import { isEmpty } from 'lodash';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Svg = styled('svg')(function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus;
  var themeTS = !isEmpty(theme) && theme.icon || {};
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, themeTS || {}), focus && themeTS[':focus'] || {}), disabled && themeTS[':disabled'] || {}), active && themeTS[':active'] || {}), hover && themeTS[':hover'] || {});
});

var Arrow = function Arrow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      color = _ref.color,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      disabled = _ref.disabled,
      _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === void 0 ? 0 : _ref$rotate;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Svg, {
    hover: hover,
    active: active,
    focus: focus,
    disabled: disabled,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(".concat(rotate, ")"),
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z",
    fill: color || theme.icon.color
  })));
};

Arrow.propTypes = {
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool,
  rotate: PropTypes.number
};

var Chevron = function Chevron(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      color = _ref.color,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      disabled = _ref.disabled,
      _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === void 0 ? 0 : _ref$rotate;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Svg, {
    hover: hover,
    active: active,
    focus: focus,
    disabled: disabled,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(".concat(rotate, ")"),
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z",
    fill: color || theme.icon.color
  })));
};

Chevron.propTypes = {
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool,
  rotate: PropTypes.number
};

var Check = function Check(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      color = _ref.color,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      disabled = _ref.disabled;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Svg, {
    hover: hover,
    active: active,
    focus: focus,
    disabled: disabled,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 16.1698L4.83003 11.9998L3.41003 13.4098L9.00003 18.9998L21 6.99984L19.59 5.58984L9.00003 16.1698Z",
    fill: color || theme.icon.color
  })));
};

Check.propTypes = {
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool
};

var Close = function Close(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      color = _ref.color,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      disabled = _ref.disabled;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Svg, {
    hover: hover,
    active: active,
    focus: focus,
    disabled: disabled,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
    fill: color || theme.icon.color
  })));
};

Close.propTypes = {
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool
};

var Help = function Help(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      color = _ref.color,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      disabled = _ref.disabled;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Svg, {
    hover: hover,
    active: active,
    focus: focus,
    disabled: disabled,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",
    fill: color || theme.icon.color
  })));
};

Help.propTypes = {
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool
};

var Info = function Info(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      color = _ref.color,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      disabled = _ref.disabled,
      rotate = _ref.rotate;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Svg, {
    hover: hover,
    active: active,
    focus: focus,
    disabled: disabled,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z",
    fill: color || theme.icon.color
  })));
};

Info.propTypes = {
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool
};

var Search = function Search(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      color = _ref.color,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      disabled = _ref.disabled;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Svg, {
    hover: hover,
    active: active,
    focus: focus,
    disabled: disabled,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z",
    fill: color || theme.icon.color
  })));
};

Search.propTypes = {
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool
};

var Refresh = function Refresh(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      color = _ref.color,
      hover = _ref.hover,
      active = _ref.active,
      focus = _ref.focus,
      disabled = _ref.disabled,
      _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === void 0 ? 0 : _ref$rotate;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Svg, {
    hover: hover,
    active: active,
    focus: focus,
    disabled: disabled,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(".concat(rotate, ")"),
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58001 4 4.01001 7.58 4.01001 12C4.01001 16.42 7.58001 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69001 18 6.00001 15.31 6.00001 12C6.00001 8.69 8.69001 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z",
    fill: color || theme.icon.color
  })));
};

Refresh.propTypes = {
  size: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  hover: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool,
  rotate: PropTypes.number
};

var IcoArrow = function IcoArrow(props) {
  return /*#__PURE__*/React.createElement(Arrow, props);
};
var IcoChevron = function IcoChevron(props) {
  return /*#__PURE__*/React.createElement(Chevron, props);
};
var IcoCheck = function IcoCheck(props) {
  return /*#__PURE__*/React.createElement(Check, props);
};
var IcoClose = function IcoClose(props) {
  return /*#__PURE__*/React.createElement(Close, props);
};
var IcoHelp = function IcoHelp(props) {
  return /*#__PURE__*/React.createElement(Help, props);
};
var IcoInfo = function IcoInfo(props) {
  return /*#__PURE__*/React.createElement(Info, props);
};
var IcoSearch = function IcoSearch(props) {
  return /*#__PURE__*/React.createElement(Search, props);
};
var IcoRefresh = function IcoRefresh(props) {
  return /*#__PURE__*/React.createElement(Refresh, props);
};

export { IcoArrow, IcoCheck, IcoChevron, IcoClose, IcoHelp, IcoInfo, IcoRefresh, IcoSearch };
